import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Button, Card, Spinner } from 'react-bootstrap-v5'
import { useAuth } from '../../../contexts/CustomContextHook/useAuth';
import { useHistory } from 'react-router-dom';
import { useHotel2 } from '../../../contexts/HotelContext';

import { GetHotelsByUser } from '../../../modules/Hotel/HotelService'

import FullPageLoader from '../../../modules/FullPageLoader'
import { KTSVG } from '../../../../_metronic/helpers';


const AllHotelsComponent = () => {

    const [Hotels, setHotels] = useState([])

    const [loading, setLoading] = useState(false)

    const { UserToken, setUserToken } = useAuth()



    const history = useHistory()
    // /hotels/hotelDashboard

    const { HotelId, setHotelId, HotelName, setHotelName } = useHotel2()
    

    var LoggedInUser = localStorage.getItem('LoggedInUserId');

    useEffect(() => {

        setHotelId('0');
        setHotelName("");

        setLoading(true);
        GetHotelsByUser(LoggedInUser, UserToken.token)
            .then(response => {
                console.log('response.data---', response.data);
                setLoading(false);
                setHotels(response.data);
            }).catch(err => { setLoading(false); });

    }, [])




    const HandleHotelClick = (Id, name) => {

        
        setHotelId(Id);
        setHotelName(name);

    
        history.push('/hotels/hotelDashboard');


    }

    return (
        <div>

            {loading &&
                <FullPageLoader />
            }
            <div className='d-flex flex-wrap m-5'>

                {Hotels.map(
                    (hotel
                        // : HotelModel, index, array
                    ) => (
                        <Card className='m-3 shadow rounded'
                        style={{width : '270px'}} 
                        // style={{ width: '21rem' }}
                            key={hotel.id}
                        >
                            <img
                                src={hotel.imageURL}
                                className='rounded-top'
                                style={{ height: '150px' }}

                            />

                            <Card.Body>
                                <Card.Title>
                                    {hotel.name}
                                </Card.Title>
                                <Card.Text>
                                    {/* Some quick example text to build on the card title and make up the bulk of
            the card's content. */}
                                </Card.Text>
                                <div className='d-flex justify-content-center'>
                                    <Button variant="primary" onClick={() => HandleHotelClick(hotel.id, hotel.name)}
                                     className='btn-md'>
                                        <p className='d-inline'>

                                            <KTSVG path='/media/icons/duotune/dashboard/db-02.svg' className='svg-icon-2' />
                                            Go to Dashboard
                                        </p>
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>

                    )
                )}

            </div>


        </div>
    )
}

export default AllHotelsComponent
